var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAgendaReorder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 19,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.1 11.333v-.244l-.171.174-2.744 2.777V9.436H10.75V14.04l-2.743-2.777-.171-.174v2.056l.028.029 3.533 3.577.071.072.071-.072 3.533-3.577.029-.03v-1.811ZM3.9 8.347v.244l.171-.173L6.815 5.64V10.245H8.25V5.64l2.743 2.778.171.173V6.536l-.028-.03L7.604 2.93l-.071-.072-.071.072-3.533 3.577-.029.029v1.811Z",
  fill: "#98A4AF",
  stroke: "#98A4AF",
  strokeWidth: 0.2
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 17.5,
  height: 17.5,
  rx: 1.25,
  stroke: "#98A4AF",
  strokeWidth: 1.5
})));
export { SvgAgendaReorder as ReactComponent };
export default __webpack_public_path__ + "9d78ba7f0352df6c575282a750e0c77d.svg";